const createUrl = ({ originCity, originState, destCity, destState, equipmentType, daysFromToday, orderNumber, radius, manageStatus }) => {
  const url = `${originCity ? `&originCity=${originCity}` : ''}${originState ? `&originState=${originState}` : ''}${destCity ? `&destCity=${destCity}` : ''}${destState ? `&destState=${destState}` : ''}${equipmentType ? `&equipmentType=${equipmentType}` : ''}${daysFromToday ? `&daysFromToday=${daysFromToday}` : ''}${orderNumber ? `&orderNumber=${orderNumber}` : ''}${radius ? `&radius=${radius}` : ''}${manageStatus ? `&manageStatus=${manageStatus}` : ''}`

  return url
}

export default {

  get: ({ offset, filterBy = 'available', limit = 20 }, body) => {
    const url = `/carrier/offers?read&filter_by=${filterBy}&limit=${limit}&offset=${offset * limit}`
    const completeUrl = createUrl(body)
    return `${url}${completeUrl}`
  },
  history: ({ offset, limit = 20 }, body) => {
    const url = `/carrier/offers?read&filter_by=history&&limit=${limit}&offset=${offset * limit}`
    const completeUrl = createUrl(body)
    return `${url}${completeUrl}`
  },
  markUnmark: (movementNumber, isMark) => {
    const completeUrl = isMark ? 'unmark_order' : 'mark_order'
    return `/carrier/offers/markers?${completeUrl}&movement_number=${movementNumber}`
  }
}
